import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginComponent from '../components/Auth/LoginPage';
import { useAuth } from '../contexts/AuthContext';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (token: string) => {
    try {
      await login(token);
      navigate('/dashboard', { replace: true });
    } catch (error) {
      console.error('Login failed:', error);
      // Error is handled by the auth context
    }
  };

  return <LoginComponent onLogin={handleLogin} />;
};

export default LoginPage;